import * as types from "./action-types";
import * as fb from "../../firebase/firebasejs";
import firebase from "firebase";
import { fechahora } from "../../services/utils";
import { showSnackbar } from "./organizers-actions";


let lastEventIndex = null;
let activeListeners = {};

export function eventParticipants(eventoIndex) {
  console.log("Participantes o inscritos Evento evento");

  const basePath = `${fb.EventosCompletos}/${eventoIndex}/${fb.inscritos}${fb.listadoInscritos}`;

  // Si el eventoIndex cambió, limpiamos los listeners del anterior
  if (lastEventIndex && activeListeners[lastEventIndex]) {
    console.log("Limpiando listeners del evento anterior:", lastEventIndex);
    activeListeners[lastEventIndex].ref.off();
    activeListeners[lastEventIndex].addedRef.off();
    delete activeListeners[lastEventIndex];
  }

  // Actualizamos el último eventoIndex usado
  lastEventIndex = eventoIndex;

  return (dispatch, getState) => {
    const userID = getState().atlete.userID;

    // Un perfil "inscriptor" solo debe ver sus propios registros — la
    // regla de RTDB exige que la consulta venga acotada exactamente por
    // orderByChild('usuarioRegistra').equalTo(uid) para ese perfil
    // específico (ver database.rules.json); cualquier otro perfil
    // (MasterOrganizador, MasterCliente, Kits, Web, Staff) sigue viendo la
    // lista completa del evento, igual que antes. Sin acotar la consulta
    // así, un inscriptor ve la data completa en el store y la puede
    // consultar con el buscador aunque la pantalla solo le muestre "sus"
    // registros — esto hace que RTDB directamente no le envíe el resto.
    fb.db
      .ref(`${fb.EventosCompletos}/${eventoIndex}/${fb.OganizadoresEvento}${userID}/perfil`)
      .once("value")
      .then((perfilSnap) => {
        const esInscriptor = perfilSnap.val() === "inscriptor";

        const ref = esInscriptor
          ? fb.db.ref(basePath).orderByChild("usuarioRegistra").equalTo(userID)
          : fb.db.ref(basePath);
        const addedRef = ref.limitToLast(1);

        // Guardamos los nuevos refs (si mientras tanto se volvió a llamar
        // esta función para otro evento, ya se limpió arriba antes de
        // llegar acá, así que no hay riesgo de pisar una entrada vigente).
        activeListeners[eventoIndex] = {
          ref,
          addedRef,
        };

        ref.once("value", (snapshot) => {
          console.log(snapshot.val());
          console.log("events participan value");

          let participantsPrev = snapshot.val();

          let participants = {};
          for (var i in participantsPrev) {
            participants[i] = { ...participantsPrev[i], key: i }

          }

          dispatch({
            type: types.EVENT_PARTICIPANTS,
            eventParticipants: participants,
            eventParticipantsRequested: true,
            eventParticipantsEventIndex: eventoIndex,
          });
        });

        // ====== bufferea child_changed/child_added/child_removed ======
        // Misma lógica que resultadosEventoNew (events-actions.js): cuando
        // hay muchos cambios seguidos en poco tiempo — por ejemplo, al
        // marcar entregas de kit una tras otra durante el evento — cada
        // dispositivo conectado escuchando esta misma lista recibía un
        // dispatch (y por lo tanto un render) por cada cambio individual.
        // Acá se acumulan los cambios y se aplican de una sola vez, con un
        // retraso que crece si detecta una ráfaga de muchos cambios por
        // segundo, para que los dispositivos no se pongan lentos.
        let burstCount = 0;
        let burstWindowStart = 0;
        const baseDelay = 500;

        const getAdaptiveDelay = () => {
          const now = Date.now();
          if (burstWindowStart === 0 || now - burstWindowStart > 1000) {
            burstWindowStart = now;
            burstCount = 0;
          }
          burstCount++;

          if (burstCount > 400) return 8000;
          if (burstCount > 200) return 5000;
          if (burstCount > 80) return 2000;

          return baseDelay;
        };

        const upsertsByKey = {};
        const removedKeys = new Set();
        let flushTimer = null;

        const flush = () => {
          flushTimer = null;
          if (Object.keys(upsertsByKey).length === 0 && removedKeys.size === 0) {
            return;
          }

          const upserts = { ...upsertsByKey };
          const removed = Array.from(removedKeys);
          Object.keys(upsertsByKey).forEach((key) => delete upsertsByKey[key]);
          removedKeys.clear();

          dispatch({
            type: types.EVENT_PARTICIPANTS_BATCH,
            eventParticipantsUpserts: upserts,
            eventParticipantsRemoved: removed,
          });
        };

        const scheduleFlush = () => {
          if (flushTimer) return;
          flushTimer = setTimeout(flush, getAdaptiveDelay());
        };

        ref.on("child_changed", (snapshot) => {
          const participant = snapshot.val();
          upsertsByKey[snapshot.key] = { ...participant, key: snapshot.key };
          removedKeys.delete(snapshot.key);
          scheduleFlush();
        });
        addedRef.on("child_added", (snapshot) => {
          const participant = snapshot.val();
          upsertsByKey[snapshot.key] = { ...participant, key: snapshot.key };
          removedKeys.delete(snapshot.key);
          scheduleFlush();
        });
        ref.on("child_removed", (snapshot) => {
          removedKeys.add(snapshot.key);
          delete upsertsByKey[snapshot.key];
          scheduleFlush();
        });
      });
  };
}
let lastEventIndexConfiguracion = null;
let activeListenersConfiguracion = {};

// RegistryContainerUI.jsx dispatcha esto desde mapDispatchToProps, que
// vuelve a correr cada vez que cambia match (es decir, cada vez que el
// usuario entra a otro evento sin recargar la página) — sin esta limpieza,
// el listener del evento anterior se queda escuchando y puede sobrescribir
// registryConfiguration con datos del evento equivocado. Mismo patrón que
// ya usa eventParticipants arriba.
export function registryConfiguration(eventoIndex) {
  console.log("Participantes o inscritos Evento evento");

  if (
    lastEventIndexConfiguracion &&
    activeListenersConfiguracion[lastEventIndexConfiguracion]
  ) {
    activeListenersConfiguracion[lastEventIndexConfiguracion].off();
    delete activeListenersConfiguracion[lastEventIndexConfiguracion];
  }
  lastEventIndexConfiguracion = eventoIndex;

  var ref = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.InscripcionesConfiguracion}`
  );
  activeListenersConfiguracion[eventoIndex] = ref;

  return (dispatch) => {
    ref.on("value", (snapshot) => {
      console.log(snapshot.val());
      dispatch({
        type: types.REGISTRY_CONFIGURATION,
        registryConfiguration: snapshot.val(),
      });
    });
  };
}
// Historial de correos de campaña (Fase 2 del editor de correos) — vive en
// el árbol principal del evento (eventosCompletos/{evento}/campaigns), NO
// dentro de inscripcionesConfiguracion, porque esa última se carga por
// completo para cualquier usuario autorizado del evento (ver
// registryConfiguration arriba) y este historial trae datos de contacto de
// atletas reales. Las reglas de RTDB deben restringir esta ruta a master/
// MasterOrganizador. Por eso también es lectura puntual (once, no
// listener persistente) y solo se pide al entrar a esa vista específica,
// no como parte de la carga general del evento.
export function eventCampaigns(eventoIndex) {
  var ref = fb.db.ref(`${fb.EventosCompletos}${eventoIndex}/campaigns`);
  return (dispatch) => {
    return ref.once("value", (snapshot) => {
      dispatch({
        type: types.EVENT_CAMPAIGNS,
        eventCampaigns: snapshot.val(),
      });
    });
  };
}

let lastEventIndexAutorizados = null;
let activeListenersAutorizados = {};

// Mismo motivo que registryConfiguration arriba: se redispatcha en cada
// cambio de evento vía mapDispatchToProps, hay que cerrar el listener del
// evento anterior antes de abrir el nuevo.
export function registryAutorizedUsers(eventoIndex) {
  console.log("usuarios autorizados o inscritos Evento evento");

  if (
    lastEventIndexAutorizados &&
    activeListenersAutorizados[lastEventIndexAutorizados]
  ) {
    activeListenersAutorizados[lastEventIndexAutorizados].off();
    delete activeListenersAutorizados[lastEventIndexAutorizados];
  }
  lastEventIndexAutorizados = eventoIndex;

  var ref = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.OganizadoresEvento}`
  );
  activeListenersAutorizados[eventoIndex] = ref;

  return (dispatch) => {
    ref.on("value", (snapshot) => {
      console.log(snapshot.val());
      dispatch({
        type: types.REGISTRY_AUTORIZED_USERS,
        registryAutorizedUsers: snapshot.val(),
      });
    });
  };
}

// Fija a mano registryParticipantData/registryParticipantKey en el store,
// replicando lo que ya hace el listener .on() de registryParticipantDataFunc
// — necesario para el atleta líder de un grupo (guardado con
// guardarAtletaPendienteEnGrupo, que no pasa por ese listener) porque
// PaymentsView/CardPayment.jsx leen el inscritoKey a cobrar desde
// registryParticipantKey del store, no como prop.
//
// El primer dispatch es solo para que la UI tenga algo que mostrar de
// inmediato (sin esperar un round-trip a Firebase) — pero SIN el .on()
// de abajo, el store se queda congelado con los datos de ANTES de pagar:
// la confirmación del líder del grupo nunca se entera cuando statusPago
// pasa a "ok" ni cuando el backend asigna el folio después, aunque
// RegistryConfirmation.jsx ya tenga su propia lógica para esperar el
// folio (sincronizarEsperaFolio) — esa lógica depende de recibir props
// actualizadas, que es justo lo que este .on() entrega.
export function fijarParticipanteActual(eventoIndex, inscritoKey, atleteData) {
  return (dispatch) => {
    dispatch({
      type: types.REGISTRY_PARTICIPANT_DATA,
      registryParticipantData: atleteData,
      registryParticipantKey: inscritoKey,
      registryError: null,
    });

    var route = `${fb.EventosCompletos}${eventoIndex}/${fb.inscritos}${fb.listadoInscritos}`;
    fb.db.ref(`${route}${inscritoKey}/`).on("value", (snapshot) => {
      dispatch({
        type: types.REGISTRY_PARTICIPANT_DATA,
        registryParticipantData: snapshot.val(),
        registryParticipantKey: snapshot.key,
        registryError: null,
      });
    });
  };
}

export function resetRegistryParticipantData() {
  return (dispatch) => {
    dispatch({
      type: types.RESET_REGISTRY_PARTICIPANT_DATA,
      registryParticipantData: null,
      registryParticipantKey: null,
      registryError: null,
    });
  };
}

export function registryParticipantDataFunc(
  eventoIndex,
  atleteData,
  formaDeInscripcionparam,
  userID
) {
  //resetRegistryParticipantData();
  console.log("Guardar Datos de inscripcion");

  if (userID === undefined) {
    atleteData.usuarioRegistra = "No registrado";
  } else {
    atleteData.usuarioRegistra = userID;
  }
  atleteData.fechaRegistro = fechahora();
  atleteData.serverTime = firebase.database.ServerValue.TIMESTAMP;

  // 1 Inscripcion en linea
  // 2 Inscricppcion en punto de venta
  // 3 inscripcion por codigo

  if (formaDeInscripcionparam === 1) {
    atleteData.tipoRegistro = formaDeInscripcionparam;
    atleteData.statusPago = {
      status: "pendiente",
      formaInscripcion: "en linea",
      formaPago: "",
      fechaPago: "",
      serverTime: firebase.database.ServerValue.TIMESTAMP,
      idOperacion: 0,
    };
  } else if (formaDeInscripcionparam === 2) {
    atleteData.tipoRegistro = formaDeInscripcionparam;
    atleteData.statusPago = {
      status: "ok",
      formaInscripcion: "punto de Venta",
      formaPago: "efectivo",
      fechaPago: fechahora(),
      serverTime: firebase.database.ServerValue.TIMESTAMP,
      idOperacion: 0,
    };
  } else if (formaDeInscripcionparam === 3) {
    atleteData.tipoRegistro = formaDeInscripcionparam;
    atleteData.statusPago = {
      status: "ok",
      formaInscripcion: "Codigo de inscripción",
      formaPago: "efectivo",
      fechaPago: fechahora(),
      serverTime: firebase.database.ServerValue.TIMESTAMP,
      idOperacion: 0,
    };
  } else if (formaDeInscripcionparam === 4) {
    atleteData.tipoRegistro = 2; // seteo a 2 para ver enviar correo como ya pagado
    atleteData.statusPago = {
      status: "ok",
      formaInscripcion: "en linea",
      formaPago: "efectivo",
      fechaPago: fechahora(),
      serverTime: firebase.database.ServerValue.TIMESTAMP,
      idOperacion: 0,
    };
  }

  var route = `${fb.EventosCompletos}${eventoIndex}/${fb.inscritos}${fb.listadoInscritos}`;
  var inscritoKey = fb.db
    .ref()
    .child(route)
    .push().key;

  var updates = {};

  updates[`${route}${inscritoKey}/`] = atleteData;

  var ref = fb.db.ref(`${route}${inscritoKey}/`);
  return (dispatch) => {
    fb.db
      .ref()
      .update(updates)
      .then(function () {
        ref.on("value", (snapshot) => {
          console.log(snapshot.val());
          dispatch({
            type: types.REGISTRY_PARTICIPANT_DATA,
            registryParticipantData: snapshot.val(),
            registryParticipantKey: snapshot.key,
            registryError: null,
          });
        });
      })
      .catch(function (error) {
        dispatch({
          type: types.REGISTRY_PARTICIPANT_DATA,
          registryParticipantData: null,
          registryParticipantKey: null,
          registryError: error,
        });
      });
  };
}
// Recupera un registro incompleto (statusPago.status === "pendiente") del
// panel admin: genera un registro NUEVO con los mismos datos, pagado en
// efectivo a nombre de quien lo recupera, y marca el original (que sigue
// visible en el listado) como recuperado. Todo en un solo multi-path
// .update() para que ambas escrituras sean atómicas — si una falla, no
// queda un registro nuevo huérfano ni un original marcado sin su copia.
//
// El shape de statusPago/tipoRegistro de acá replica a propósito la rama
// formaDeInscripcionparam===4 de registryParticipantDataFunc (arriba) en
// vez de llamarla — esa función hace su propio push()+update() y no deja
// encadenar la segunda escritura sobre el ORIGINAL en la misma operación
// atómica. Si ese shape cambia alguna vez, actualizar ambos lugares.
export function recuperarRegistroIncompleto(eventoIndex, originalKey, originalData, userID, atleteAccount) {
  return (dispatch) => {
    var route = `${fb.EventosCompletos}${eventoIndex}/${fb.inscritos}${fb.listadoInscritos}`;
    var nuevoInscritoKey = fb.db
      .ref()
      .child(route)
      .push().key;

    // El nuevo registro no hereda bitácora de cambios ni historial de
    // correos del original — empieza limpio, y así el código 2 de
    // tipoRegistro (que ya dispara el correo "ya pagado") no se confunde
    // con logs de un registro que, para efectos de este nuevo, no existía
    // todavía. recuperadoDe queda como referencia hacia el original.
    var clone = { ...originalData };
    delete clone.usuarioRegistra;
    delete clone.fechaRegistro;
    delete clone.serverTime;
    delete clone.tipoRegistro;
    delete clone.statusPago;
    delete clone.recuperado;
    delete clone.recuperadoPor;
    delete clone.recuperadoFecha;
    delete clone.recuperadoComo;
    delete clone.changesRegistry;
    delete clone.mails;

    clone.usuarioRegistra = userID;
    clone.fechaRegistro = fechahora();
    clone.serverTime = firebase.database.ServerValue.TIMESTAMP;
    clone.tipoRegistro = 2; // mismo código que un pago en efectivo normal (CashPayment.jsx) — dispara el correo "ya pagado"
    clone.statusPago = {
      status: "ok",
      // "punto de Venta" (no "en linea"): así pivotEngine.js/DashboardContainer.jsx
      // (resolveFieldValue del campo "usuarioRegistra") atribuyen este pago
      // por completo al usuarioRegistra (quien recuperó el registro) en los
      // reportes, en vez de contarlo como un registro en línea anónimo.
      formaInscripcion: "punto de Venta",
      formaPago: "efectivo",
      fechaPago: fechahora(),
      serverTime: firebase.database.ServerValue.TIMESTAMP,
      idOperacion: 0,
    };
    clone.recuperadoDe = originalKey;

    // El registro incompleto viene de la vista pública, que agrega un ítem
    // "comisión" a la orden (cobro de procesar el pago en línea) — mismo
    // código que ya filtra EventRegistryPublicForm.jsx al armar la orden
    // sin comisión para otros medios de pago. Como ahora el cobro es en
    // efectivo (sin pasarela de pago de por medio), ese cargo no aplica.
    //
    // Si el registro es parte de un grupo (varios atletas, un solo pago —
    // ver GroupRegistrySummary.jsx/registroGrupal.js), el panel admin lo
    // recupera de forma individual, no como grupo: se quitan los ítems que
    // lo vinculaban a otro registro, para que quede como una inscripción
    // normal e independiente.
    // - Líder: items "atleta-vinculado" con inscritoKeyVinculado (el costo
    //   de cada atleta adicional, que ya no le corresponde pagar a este
    //   registro una vez separado).
    // - Integrante: item "pago-en-grupo" que dejaba su orden en $0 (al
    //   quitarlo, su orden vuelve a reflejar lo que realmente le
    //   corresponde pagar).
    if (Array.isArray(clone.order)) {
      clone.order = clone.order.filter(
        (item) =>
          item &&
          item.code !== "comision" &&
          !item.inscritoKeyVinculado &&
          item.code !== "pago-en-grupo"
      );
    }

    var fechaRecuperacion = fechahora();
    var changesRegistry = fb.changesRegistryFunc(
      originalKey,
      originalData,
      userID,
      atleteAccount,
      23,
      "Registro incompleto recuperado y marcado como pagado en efectivo"
    );

    var updates = {};
    updates[`${route}${nuevoInscritoKey}/`] = clone;
    updates[`${route}${originalKey}/recuperado`] = true;
    updates[`${route}${originalKey}/recuperadoPor`] = userID;
    updates[`${route}${originalKey}/recuperadoFecha`] = fechaRecuperacion;
    updates[`${route}${originalKey}/recuperadoComo`] = nuevoInscritoKey;
    updates[`${route}${originalKey}/changesRegistry/`] = changesRegistry;

    var ref = fb.db.ref(`${route}${nuevoInscritoKey}/`);
    return fb.db
      .ref()
      .update(updates)
      .then(function () {
        dispatch(showSnackbar(true, "Registro recuperado y marcado como pagado", 4000));
        ref.on("value", (snapshot) => {
          dispatch({
            type: types.REGISTRY_PARTICIPANT_DATA,
            registryParticipantData: snapshot.val(),
            registryParticipantKey: snapshot.key,
            registryError: null,
          });
        });
      })
      .catch(function (error) {
        dispatch(showSnackbar(true, "No se pudo recuperar el registro: " + error.message, 6000));
      });
  };
}
// --- Registro de varios atletas antes de un solo pago ---
// Estas funciones son planas (no thunks, no usan dispatch) porque el grupo
// de atletas se lleva en el estado del propio componente
// EventRegistryPublicForm.jsx, no en Redux — registryParticipantData/
// registryParticipantKey del store están pensados para UN atleta "actual" a
// la vez (usan un listener .on() persistente) y se quedarían mal si se
// reusaran para guardar varios atletas en la misma sesión. No tocan ni
// reusan registryParticipantDataFunc para no arriesgar el flujo normal de
// un solo atleta, que sigue exactamente igual que antes.

// Guarda un atleta como registro pendiente (mismo shape que un registro
// tipo 1 normal: tipoRegistro=1, statusPago "pendiente") y devuelve una
// promesa con el inscritoKey ya generado.
export function guardarAtletaPendienteEnGrupo(eventoIndex, atleteData, userID) {
  const datos = { ...atleteData };
  datos.usuarioRegistra = userID === undefined ? "No registrado" : userID;
  datos.fechaRegistro = fechahora();
  datos.serverTime = firebase.database.ServerValue.TIMESTAMP;
  datos.tipoRegistro = 1;
  datos.statusPago = {
    status: "pendiente",
    formaInscripcion: "en linea",
    formaPago: "",
    fechaPago: "",
    serverTime: firebase.database.ServerValue.TIMESTAMP,
    idOperacion: 0,
  };

  const route = `${fb.EventosCompletos}${eventoIndex}/${fb.inscritos}${fb.listadoInscritos}`;
  const inscritoKey = fb.db.ref().child(route).push().key;
  const updates = {};
  updates[`${route}${inscritoKey}/`] = datos;

  return fb.db
    .ref()
    .update(updates)
    .then(() => ({ inscritoKey, atleteData: datos }));
}

// Sobreescribe el `order` de un registro ya guardado — se usa al armar el
// resumen del grupo, justo antes de pagar, para consolidar la orden del
// líder (sus propios ítems + un resumen por cada atleta vinculado + la
// comisión sobre el total) y para agregar a cada atleta adicional el ítem
// que lleva su pago a $0.
export function actualizarOrdenDeRegistro(eventoIndex, inscritoKey, order) {
  const route = `${fb.EventosCompletos}${eventoIndex}/${fb.inscritos}${fb.listadoInscritos}${inscritoKey}/order`;
  return fb.db.ref(route).set(order);
}

// Quita a un atleta del grupo antes de pagar (o cancela el grupo completo,
// llamándola para cada inscritoKey). Marca el registro pendiente como
// borrado, mismo campo que ya usa el resto del sistema para registros
// eliminados — no dispara ningún cobro ni correo, el registro sigue sin
// pago (tipoRegistro=1, statusPago "pendiente").
export function marcarAtletaRemovidoDelGrupo(eventoIndex, inscritoKey) {
  const route = `${fb.EventosCompletos}${eventoIndex}/${fb.inscritos}${fb.listadoInscritos}${inscritoKey}/borrado`;
  return fb.db.ref(route).set(true);
}

export function registryFormDataFunc(eventoIndex, formId, formData) {
  //resetRegistryParticipantData();
  console.log("Guardar Datos formulario");

  var route = `${fb.EventosCompletos}${eventoIndex}/${fb.formsData}/${formId}/`;
  var itemKey = fb.db
    .ref()
    .child(route)
    .push().key;

  var updates = {};

  formData.date = new Date().getTime();
  updates[`${route}${itemKey}/`] = formData;

  var ref = fb.db.ref(`${route}${itemKey}/`);
  return (dispatch) => {
    fb.db
      .ref()
      .update(updates)
      .then(function () {
        ref.on("value", (snapshot) => {
          console.log(snapshot.val());
          dispatch({
            type: types.REGISTRY_FORM_DATA,
            registryFormData: snapshot.val(),
            registryFormKey: snapshot.key,
            registryError: null,
          });
        });
      })
      .catch(function (error) {
        dispatch({
          type: types.REGISTRY_FORM_DATA,
          registryFormData: null,
          registryFormKey: null,
          registryError: error,
        });
      });
  };
}

export function getallDataForConfirmationFunc(eventoIndex, inscritoKey) {
  // 	//resetRegistryParticipantData();
  console.log("registryParticipantData", eventoIndex, inscritoKey);

  var ref = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.InscripcionesConfiguracion}`
  );
  return (dispatch) => {
    ref.on("value", (snapshot) => {
      console.log(snapshot.val());
      dispatch({
        type: types.REGISTRY_CONFIGURATION,
        registryConfiguration: snapshot.val(),
      });
      return fb.db
        .ref(
          "/eventosCompletos/" +
          eventoIndex +
          "/inscritos/listadoInscritos/" +
          inscritoKey
        )
        .once("value")
        .then((snap) => {
          console.log("registryParticipantData", snap.val());
          dispatch({
            type: types.REGISTRY_PARTICIPANT_DATA,
            registryParticipantData: snap.val(),
            registryParticipantKey: snap.key,
            registryError: null,
          });
          return fb.db
            .ref(
              "/eventosCompletos/" +
              eventoIndex +
              "/inscripcionesConfiguracion/"
            )
            .once("value");
        })
        .then((snap) => {
          dispatch({
            type: types.REGISTRY_CONFIGURATION,
            registryConfiguration: snap.val(),
          });
        });
    });
  };

  //   return db.ref('/eventosCompletos/'+eventoIndex+"/inscritos/listadoInscritos/"+inscritoKey).once('value')
  // 	.then(snap => {
  // 	  jsonData.datos = snap.val();
  //   return db.ref('/eventosCompletos/'+eventoIndex+'/inscripcionesConfiguracion/').once('value');
  // 	}).then(snap => {
  // 	  jsonData.inscripcionesConfiguracion = snap.val();
  // 	  JSONFormInscripcion = jsonData.inscripcionesConfiguracion;
  // 	  setBaseCurrency();

  //   return db.ref('/eventosCompletos/'+eventoIndex+'/detalleEvento/').once('value');
  // 	}).then(snap => {
  // 	  jsonData.detalleEvento = snap.val();
  //   return db.ref('/eventosCompletos/'+eventoIndex+'/modalidades/').once('value');
  // 	}).then(snap => {
  // 	  jsonData.modalidades = snap.val();

  // 	  return;
  // 	}).then(()=>{
  // 		if(descarga){
  // 		  console.log("descargar automatico");
  // 		  return setTimeout(()=> { return downloadDeslindePDFHTML(jsonData);},100)
  // 		  //return downloadDeslindePDF(jsonData);
  // 		}else {
  // 		  return;
  // 		}
  // 	});
}

export function generateVirtualEventsLink(
  eventParticipants,
  eventoIndex,
  eventSubEventsRegistry
) {
  return (dispatch) => {
    for (var i in eventParticipants) {
      console.log(eventSubEventsRegistry);
      let eventID = undefined;
      if (
        eventSubEventsRegistry[
        "modalidad_" + eventParticipants[i].modalidad
        ] !== undefined &&
        eventSubEventsRegistry["modalidad_" + eventParticipants[i].modalidad]
          .virtualEventId !== undefined
      ) {
        eventID =
          eventSubEventsRegistry["modalidad_" + eventParticipants[i].modalidad]
            .virtualEventId;
      }
      console.log(eventID);
      if (eventParticipants[i].numero !== undefined && eventID !== undefined) {
        setTimeout(
          createEventPass(eventID, eventoIndex, i, eventParticipants[i].numero),
          10
        );
      }
    }
  };
}
export function sendAllMails(
  eventParticipants,
  eventoIndex,
  eventSubEventsRegistry
) {
  return (dispatch) => {
    let x = 0;
    for (var i in eventParticipants) {
      console.log(eventSubEventsRegistry);
      if (
        eventParticipants[i].numero !== undefined &&
        !eventParticipants[i].borrado
      ) {
        console.log(x++);
        setTimeout(reenviarConfirmacion(eventoIndex, i), 100);
      }
    }
  };
}

function reenviarConfirmacion(eventoIndex, idRegistro) {
  console.log("reenviar");

  var updates = {};
  console.log(
    "eventosCompletos/" +
    eventoIndex +
    "/inscritos/listadoInscritos/" +
    idRegistro +
    "/mails/sendMail/"
  );
  updates[
    "eventosCompletos/" +
    eventoIndex +
    "/inscritos/listadoInscritos/" +
    idRegistro +
    "/mails/sendMail/"
  ] = true;
  return fb.db
    .ref()
    .update(updates)
    .then((snap) => {
      console.log("Renviada");
    });
}

function createEventPass(eventID, eventoIndex, inscritoKey, raceNumber) {
  console.log(eventID, eventoIndex, inscritoKey, raceNumber);
  const docRef = fb.firestore
    .collection("virtualEvents")
    .doc(eventID)
    .collection("eventPass");
  const date = Date.now() / 1000;

  const object = {
    userID: eventoIndex,
    code: inscritoKey,
    uses: 1,
    active: true,
    date: date,
    raceNumber: raceNumber,
  };

  return docRef.doc(inscritoKey).set(object);
}
// #########################################################################################
export function getFormData(eventoIndex, inputGroup) {
  const ref = fb.db.ref(
    `${fb.EventosCompletos}/${eventoIndex}/${fb.formsData}/${inputGroup}`
  );
  console.log("eventWeb");

  return (dispatch) => {
    dispatch({
      type: types.FORM_DATA,
      formData: {},
      inputGroup: null,
    });
    ref.on("value", (snapshot) => {
      console.log(snapshot.val());
      dispatch({
        type: types.FORM_DATA,
        formData: snapshot.val(),
        inputGroup: inputGroup,
      });
    });
  };
}
// #########################################################################################

export function eventCodes(eventoIndex) {
  console.log("Codigos del evento Evento evento");

  return (dispatch) => {
    var ref = fb.db.ref(
      `${fb.EventosCompletos}/${eventoIndex}/${fb.CodigosDescuento}${fb.Codigos}`
    );
    // Un solo listener de "value": trae el nodo completo cada vez que algo
    // adentro cambia. Antes se usaba .once("value") + child_added/
    // child_changed/child_removed por separado — pero child_added repite UN
    // evento por cada código YA EXISTENTE al engancharse el listener, y cada
    // uno disparaba en el reducer un merge que copia todo codesList
    // (Object.assign de todo lo acumulado hasta ese punto). Para una lista
    // larga (cientos o miles de códigos) eso es O(n²) solo para abrir la
    // pantalla — la causa real de que se quedara colgada. Con un solo
    // "value" el costo es O(n), una vez, igual que ya hace eventCodesGroups.
    ref.on("value", (snapshot) => {
      dispatch({
        type: types.CODES_LIST,
        codesList: snapshot.val(),
      });
    });
  };
}
// #########################################################################################

export function eventCodesGroups(eventoIndex) {
  console.log("Codigos del evento Evento evento");

  return (dispatch) => {
    var ref = fb.db.ref(
      `${fb.EventosCompletos}/${eventoIndex}/${fb.CodigosDescuento}${fb.GruposCodigos}`
    );
    ref.on("value", (snapshot) => {
      console.log(snapshot.val());
      console.log("events participan value");
      dispatch({
        type: types.CODES_GROUPS,
        codesGroups: snapshot.val(),
      });
    });
  };
}
// #########################################################################################

export function createEventCodes(
  eventoIndex,
  codeGroupKey,
  codeGroup,
  codesList
) {
  console.log("Crear Codigos del evento Evento evento");

  console.log("Route", eventoIndex);
  console.log("Route", codeGroupKey);
  console.log("Route", codeGroup);
  console.log("Route", codesList);

  const route = `${fb.EventosCompletos}${eventoIndex}/${fb.CodigosDescuento}`;
  var updates = {};
  // registro el grupo de códigos en la lista
  updates[`${route}${fb.GruposCodigos}${codeGroupKey}/`] = codeGroup;

  for (var i in codesList) {
    updates[`${route}${fb.Codigos}${i}/`] = codesList[i];
  }

  console.log("Route", route);
  console.log("Route", updates);

  const cantidadCodigos = Object.keys(codesList || {}).length;
  const mensajeExito =
    cantidadCodigos > 1
      ? `${cantidadCodigos} códigos generados correctamente`
      : "Código generado correctamente";

  return (dispatch) => {
    // Se retorna la promesa (antes no) para que quien dispara la creación
    // (CreateCode.jsx) pueda esperar a que termine y recién ahí cerrar su
    // propio diálogo/confirmar en pantalla, en vez de cerrarse de inmediato
    // sin saber si la escritura tuvo éxito.
    return fb.db
      .ref()
      .update(updates)
      .then(function () {
        console.log("Códigos registrados");
        dispatch(showSnackbar(true, mensajeExito, 5000));
      })
      .catch(function (error) {
        console.log(" ERROR Códigos NO registrados");
        dispatch(showSnackbar(true, "Error al generar los códigos", 5000));
        throw error;
      });
  };
}
// #########################################################################################
